const getters = {
  sidebar: state => state.app.sidebar,
  size: state => state.app.size,
  device: state => state.app.device,
  dict: state => state.dict.dict,
  visitedViews: state => state.tagsView.visitedViews,
  cachedViews: state => state.tagsView.cachedViews,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  phone: state => state.user.phone,
  userName: state => state.user.userName,
  roleName: state => state.user.roleName,
  orgName: state => state.user.orgName,
  introduction: state => state.user.introduction,
  roles: state => state.user.roles,
  news: state => state.user.news,
  num: state => state.user.num,
  permissions: state => state.user.permissions,
  permission_routes: state => state.permission.routes,
  topbarRouters:state => state.permission.topbarRouters,
  defaultRoutes:state => state.permission.defaultRoutes,
  sidebarRouters:state => state.permission.sidebarRouters,
  aboutUsInfo: state => state.user.aboutUsInfo,
  aboutUsPicUrl: state => state.user.aboutUsInfo ? state.user.aboutUsInfo.picUrl : null
}
export default getters
